// 正式环境的配置（live_cms发布路径为/）
let LIVE_CMS = "/live_cms";
const DOMAIN = location.protocol + "//" + location.host;
let RELEASE = true; // 控制是否加载敏感信息（版权、下载地址等）

// LIVE_CMS_CONFIG_ENV, BUILD_VERSION 的值通过webpack插件DefinedPlugin定义
// LIVE_CMS_CONFIG_ENV取自环境变量LIVE_CMS_CONFIG_ENV
// BUILD_VERSION 取自 public/version.html 文件
// eslint-disable-next-line no-undef
if (LIVE_CMS_CONFIG_ENV == 'pro') {
    LIVE_CMS = '';
}

var ENV_CONFIG = window.ENV_CONFIG || {};
LIVE_CMS = ENV_CONFIG.liveCms || LIVE_CMS;
var API = ENV_CONFIG.apiServer || LIVE_CMS+"/cmsapi/";

// eslint-disable-next-line no-undef
console.log('BUILD ENV: ', LIVE_CMS_CONFIG_ENV);
// eslint-disable-next-line no-undef
console.log("BUILD VERSION: " + BUILD_VERSION);
window.console.log("LIVE_CMS: " + LIVE_CMS);
window.console.log("API_SERVER: " + API);

export default {
    release: RELEASE,
    domain: DOMAIN,
    liveCms: LIVE_CMS,
    apiServer: API,
    // cmsServer: RELEASE ? "/" : LIVE_CMS+"/",
    cmsServer: LIVE_CMS+"/",
    materialCmsServer: "/material_cms/",
    materialCmsWeb: "/material_cms/",
    AdminCenter: LIVE_CMS + "/admin/",
    picWordLiveUrl: LIVE_CMS+"/cms/wordLive/console.action?roomId={{id}}",
    realTimeEditUrl: LIVE_CMS+"/realEditor/default.html?id={{id}}",
    directorControlUrl: LIVE_CMS+"/director-v3/new.html?",
    directorMonitorUrl: LIVE_CMS+"/director-v3/new.html?",
    // directorTemplateUrl: LIVE_CMS+"/director-v3/effectGroupTemplate.html?effectGroupTemplateId={{id}}",
    directorTemplateUrl: LIVE_CMS+"/director-v3/effectGroupTemplate.html?",
    cloudEditorUrl: LIVE_CMS+"/cloudEditor/default.html?id={{id}}",
    virtualOfficeUrl: LIVE_CMS+"/virtualOffice/virtual_director.html?directorId={{id}}",
    virtualOfficeTemplateUrl: LIVE_CMS+"/virtualOffice/virtual_template.html?templateId={{id}}",
    livePageUrl: "/getRoomPlayPage.action?roomID={{id}}",
    liveHtmlUrl: "/liveHtml/",
    liveCategoryHtmlUrl: "/liveHtml/c/",
    FontMap: {
        "宋体": "宋体 , SimSun",
        "新宋体": "新宋体 , NSimSun",
        "黑体": "黑体 , SimHei,STHeiti",
        "仿宋": "仿宋 , FangSong,STFangsong",
        "楷体": "楷体 , KaiTi,STKaiti",
        "幼圆": "幼圆 , YouYuan",
        "隶书": "隶书 , LiSu,STLiti"
    }
}